<template>
  <div class="mainline-container" >
    
    <svg class="mainline" ref="mainline-container" v-bind:class="{'mainline-packed': isCardOpened, 'animated': animated}" viewBox="0 0 4195.46 4011.4">
      <g ref="mainlineContainer"></g>
      <circle class="station" v-bind:cx="stations.mst.coords.x" v-bind:cy="stations.mst.coords.y" r="10"/>
      <circle class="station" v-bind:cx="stations.frt.coords.x" v-bind:cy="stations.frt.coords.y" r="10"/>
      <circle class="station" v-bind:cx="stations.fanta.coords.x" v-bind:cy="stations.fanta.coords.y" r="10"/>
      <circle class="station" v-bind:cx="stations.disco.coords.x" v-bind:cy="stations.disco.coords.y" r="10"/>
      <circle class="gps" v-bind:cx="actualPos.x" v-bind:cy="actualPos.y" r="30" />

      <text class="stationName frontierland" v-bind:x="stations.frt.coords.x" v-bind:y="stations.frt.coords.y">Frontierland</text>
      <text class="stationName fantasyland" v-bind:x="stations.fanta.coords.x" v-bind:y="stations.fanta.coords.y">Fantasyland</text>
      <text class="stationName discoveryland" v-bind:x="stations.disco.coords.x" v-bind:y="stations.disco.coords.y">Discoveryland</text>
      <text class="stationName mainstreet" v-bind:x="stations.mst.coords.x" v-bind:y="stations.mst.coords.y">Mainstreet U.S.A</text>

       <circle v-for="question in questions" :key="question.id" v-on:click="questionClicked(question.id)" class="question" v-bind:cx="question.pos.x" v-bind:cy="question.pos.y" r="10"/>
      
    </svg>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Map',

  props: {
    animated: { type: Boolean, default: true },
    simu: { type: Boolean, default: false }
  },

  data(){
    return {
      actualPos: {x:0, y:0},
      actualPct: 0,
      actualJourneyPct: 0,
      isCardOpened: false,
      canvasSize: {x: 0, y: 0},
      sliderScale: 4.5,
      canvasOriginalSize: {x: 0, y: 0},
      pointTest: [48.870191, 2.772141],
      center: [48.872616, 2.776381],
      fakePct: 32.6,
      questions: [],
      quizWaiting : undefined,
      positionWatcher: undefined,
      journey: {
        origin: [48.870191, 2.772141],
        pct   : 0
      },
      startingDist: 3752,
      gps: [0,0],
      stations: {
        mst: {
          track : 3752,
          pct   : 0,
          gps   : [48.870825, 2.779144],
          coords: {x: 0, y: 0}
        },
        frt: {
          track : 6369,
          pct   : 33,
          gps   : [48.869883, 2.772422],
          coords: {x: 0, y: 0}
        },
        fanta: {
          track : 8790,
          pct   : 51,
          gps   : [48.869883, 2.772422],
          coords: {x: 0, y: 0}
        },
        disco: {
          track : 1746,
          pct   : 80,
          gps   : [48.869883, 2.772422],
          coords: {x: 0, y: 0}
        },
      }
    }
  },

  watch: {
    isCardOpened: function(v){
      //console.log(this.isCardOpened);
    },

    actualPct: function(p){

      this.actualJourneyPct = this.getPctOnJourneyFromPct(p);
      console.log("Actual PCT is now "+p+"%");
    },

    actualJourneyPct: function(p){
      if( this.$parent.journeyUpdated !== "undefined" ){
        this.$parent.journeyUpdated(p);
      }
    }
  },

  methods: {
    isPointLeftOfLine: function(p, d1, d2){
      return (p.x-d1.x)*(d2.y-d1.y)-(p.y-d1.y)*(d2.x-d1.x) < 0
    },

    distanceTwoPoints: function(a, b){
      return Math.sqrt( Math.pow((b.x - a.x), 2) + Math.pow((b.y - a.y), 2) );
    },

    middleAngle: function(a,b,c){
      var p = Math.acos( (Math.pow(a,2) + Math.pow(c,2) - Math.pow(b,2)) / (2*a*c) );
      return p * (180/Math.PI);
    },

    getTrackPositionFromDistance: function(dist){
      var point = document.querySelector("#MainLine").getPointAtLength(dist);
      return point;
    },

    getPctFromGps: function(x, y){
      var dist_c_mst     = this.distanceTwoPoints( {x: this.center[0], y: this.center[1]}, {x: this.stations.mst.gps[0], y: this.stations.mst.gps[1]} );
      var dist_c_pos     = this.distanceTwoPoints( {x: this.center[0], y: this.center[1]}, {x: x, y: y} );
      var dist_c_mst_pos = this.distanceTwoPoints( {x: this.stations.mst.gps[0], y: this.stations.mst.gps[1]}, {x: x, y: y} );
      var angle          = this.middleAngle(dist_c_mst, dist_c_mst_pos, dist_c_pos)

      if( !this.isPointLeftOfLine({"x": x,"y":y},{"x": this.center[0], "y":this.center[1]},{"x":this.stations.mst.gps[0], "y":this.stations.mst.gps[1]}) ){
        angle = 360 - angle;
      }

      return parseFloat( ( 100/360*angle ).toPrecision(3) )
    },

    getTrackDistBetween: function(a, b){
      if( b < a ){
        return document.querySelector("#MainLine").getTotalLength() - a + b;
      } else {
        return b - a;
      }
    },

    DistanceFromOriginToAbsolute: function(d){
      d += this.startingDist;
      return ( d > document.querySelector("#MainLine").getTotalLength() ? d - document.querySelector("#MainLine").getTotalLength() : d );
    },

    getDistFromPct: function(pct){
      var current   = 1;
      var stations  = Object.values(this.stations);
      var totalDist = 0;
      while( pct > 0 ){
        var pcts  = ( current == 4 ? 100 : stations[current].pct ) - stations[current-1].pct;
        var dist  = ( current == 4 ? this.getTrackDistBetween(stations[3].track, stations[0].track) : this.getTrackDistBetween(stations[current-1].track, stations[current].track) );
        var ratio = dist/pcts;

        if( pct - pcts < 0 ){ var toTake = pct; }
        else { var toTake = pcts }

        totalDist += toTake * ratio;
        pct -= toTake;
      
        current++;
      }
      return this.DistanceFromOriginToAbsolute ( totalDist );
    },

    getPositionOnTrackFromPct: function(pct){
      return this.getTrackPositionFromDistance( this.getDistFromPct(pct) );
    },

    updateMainlinePositioning: function(){
      var w = window.innerWidth;
      var h = window.innerHeight;
      var s = 4.5;

      var r = w/this.canvasOriginalSize.x;
      var rc= this.canvasSize.x / this.canvasOriginalSize.x;

      var moveX = (this.canvasOriginalSize.x/2 - this.actualPos.x)*r*s
      var moveY = (this.canvasOriginalSize.y/2 - this.actualPos.y)*r*s-(10*r*s)-(h*.30)

      // We set a limit on X offset so we have more of the park in the screen, even in the far left (Frontierland) and far right (Discoveryland) stations
      moveX = ( moveX >  (1250*s)*r ?  (1250*s)*r : moveX );
      moveX = ( moveX < -(1100*s)*r ? -(1100*s)*r : moveX );

      this.$refs['mainline-container'].style.top = moveY;
      this.$refs['mainline-container'].style.left = moveX;
    },

    fakeTravel: function(){
      this.fakePct  += 1;
      this.fakePct   = ( this.fakePct > 100 ? 0 : this.fakePct )
      this.actualPct = this.fakePct;
      this.actualPos = this.getPositionOnTrackFromPct( this.fakePct )
      this.updateMainlinePositioning()
    },

    updateGpsPosition: function(position){
      this.gps = [position.coords.latitude, position.coords.longitude];
      var pct = this.getPctFromGps(  this.gps[0], this.gps[1] );
      this.actualPct = pct;
      this.actualPos = this.getPositionOnTrackFromPct( pct );
      this.updateMainlinePositioning();
    },

    mapIsReady: function(){
      var pct = this.getPctFromGps( this.pointTest[0], this.pointTest[1] );
      this.canvasSize.x = this.$refs['mainline-container'].getBoundingClientRect().width;
      this.canvasSize.y = this.$refs['mainline-container'].getBoundingClientRect().height;

      this.canvasOriginalSize.x = 4195.46;
      this.canvasOriginalSize.y = 4011.4;

      // Setting stations points
      this.stations.mst.coords   = this.getTrackPositionFromDistance(this.stations.mst.track);
      this.stations.frt.coords   = this.getTrackPositionFromDistance(this.stations.frt.track);
      this.stations.fanta.coords = this.getTrackPositionFromDistance(this.stations.fanta.track);
      this.stations.disco.coords = this.getTrackPositionFromDistance(this.stations.disco.track);

      if(  this.quizWaiting !== undefined ){ this.updateQuizPoints(this.quizWaiting); }

      this.$emit('mapReady');

      //if( this.simu ){ this. };
    },

    loadMap: function(){
      axios("/static/map.svg", {
        onDownloadProgress: progressEvent => {
          console.log(progressEvent);
          const total = 2100000;
          const current = progressEvent.loaded

          let percentCompleted = Math.floor(current / total * 100)
          console.log('completed: ', percentCompleted)
        }
      }).then((response) => {
        this.$refs['mainlineContainer'].innerHTML = response.data;
        window.setTimeout(this.mapIsReady, 1000)
        console.log("MAP LOADED");
      });
    },

    toggleCard: function(isOpened){
      this.isCardOpened = isOpened;
    },

    setJourneyStart: function(lat, lng){
      this.journey.origin = [lat, lng];
      this.journey.pct    = this.getPctFromGps(lat,lng);
      this.journey.pct -= 0.1;
      console.log("Journey origin set. Origin is at "+this.journey.pct+"% from mainstreet station.");
      if( this.quizAwaiting !== undefined ){
        this.updateQuizForJourney( this.quizAwaiting );
      }
    },

    getPctOnJourneyFromGps: function(lat, lng){
      var pct =  this.getPctFromGps(lat, lng);
      //console.log("The point is at "+pct+"% from Mainstreet");
      return this.getPctOnJourneyFromPct(pct);
    },
    
    getPctOnJourneyFromPct: function(pct){
      this.journey.pct = parseInt(this.journey.pct);
      var p = (pct - this.journey.pct) > 0 ? (pct - this.journey.pct) : (100 - this.journey.pct + pct)
      p = parseFloat( p.toPrecision(3) );
      console.log("It means it is at "+p+"% from journey origin");
      return p;
    },

    manuallySetLocation: function(lat, lng){
      var pct = this.getPctFromGps(lat, lng);
      this.actualPos = this.getPositionOnTrackFromPct( pct );
    },

    updateQuizPoints: function(quiz){
      if( this.canvasSize.x == 0 ){
        this.quizWaiting = quiz;
        return;
      }

      this.questions = [];
      quiz.forEach( (q) => {
        this.questions.push({
          id : q.id,
          pos: this.getPositionOnTrackFromPct( this.getPctFromGps( q.position.lat, q.position.lng ) )
        });
      });
    },
    
    updateQuizForJourney: function(quiz){
      quiz.forEach( (q) => {
        var p = this.getPctOnJourneyFromGps( q.position.lat, q.position.lng );
        q.pctOnJourney = p;
      });

      this.$parent.quizzUpdatedWithJourney(quiz);
    },

    WaitingForQuizUpdateOnJourney: function(quiz){
      this.quizAwaiting = quiz;
    },

    questionClicked: function(qid){
      this.$parent.questionClicked(qid)
    },

    startFakeTravel: function(){
      this.setJourneyStart(48.870191, 2.772141);
      window.setInterval( this.fakeTravel, 2000);
    },

    positionWatcherUpdated : function(_loc){
      console.log("Watcher updated position.");
      this.updateGpsPosition(_loc);
    },

     positionWatcherFailed : function(){
      console.log("Watcher updated FAILED");
    },

    startWatchingPosition: function(_pos){
      this.setJourneyStart(_pos.coords.latitude, _pos.coords.longitude);
      this.positionWatcher = navigator.geolocation.watchPosition(this.positionWatcherUpdated, this.positionWatcherFailed, {enableHighAccuracy: false, timeout: 5000, maximumAge: 0});
    }
  },

  mounted(){
    
    //this.getPctOnJourneyFromGps(48.87010313743235, 2.7778886051670293);
    
    this.loadMap();
  }


}
</script>



// WEBPACK FOOTER //
// src/components/Map.vue